import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsersKeyIconWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 18,
	viewBox: "0 0 22 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 11.375C11.1924 11.375 13.375 9.19239 13.375 6.5C13.375 3.80761 11.1924 1.625 8.5 1.625C5.80761 1.625 3.625 3.80761 3.625 6.5C3.625 9.19239 5.80761 11.375 8.5 11.375Z",
			fill: "#0f172b"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.62512 6.5C4.62512 4.3599 6.36002 2.625 8.50012 2.625C10.6402 2.625 12.3751 4.3599 12.3751 6.5C12.3751 8.62571 10.6635 10.3516 8.54325 10.3748C8.52886 10.3747 8.51447 10.3747 8.50008 10.3747C8.48571 10.3747 8.47134 10.3747 8.45698 10.3748C6.33675 10.3516 4.62512 8.6257 4.62512 6.5ZM4.86763 11.1177C3.50196 10.042 2.62512 8.37338 2.62512 6.5C2.62512 3.25533 5.25545 0.625 8.50012 0.625C11.7448 0.625 14.3751 3.25533 14.3751 6.5C14.3751 8.3734 13.4983 10.042 12.1326 11.1178C12.3464 11.2091 12.5572 11.3086 12.7643 11.4162C13.2544 11.6708 13.4453 12.2745 13.1907 12.7646C12.9361 13.2547 12.3324 13.4456 11.8423 13.191C10.8238 12.6619 9.69437 12.3822 8.54706 12.3748C8.53143 12.3749 8.51578 12.375 8.50012 12.375C8.48445 12.375 8.4688 12.3749 8.45315 12.3748C7.30583 12.3822 6.1764 12.6619 5.15784 13.191C4.1254 13.7274 3.2372 14.5043 2.56827 15.4562C2.25072 15.9081 1.62699 16.017 1.17512 15.6994C0.723255 15.3819 0.614361 14.7582 0.931903 14.3063C1.78537 13.0918 2.91859 12.1005 4.23584 11.4162C4.443 11.3086 4.65376 11.2091 4.86763 11.1177Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3684 13.5561C21.3384 12.5861 21.5044 11.118 20.884 9.97321L18.8303 12.0268L17.5982 10.7947L19.6518 8.74104C18.4983 8.12058 17.0389 8.28662 16.0689 9.25663C15.2125 10.113 14.9853 11.3539 15.361 12.4201L12.3811 15.4C12.2063 15.5748 12.2063 15.8457 12.3811 16.0205L13.6045 17.2439C13.7793 17.4187 14.0502 17.4187 14.225 17.2439L17.2049 14.264C18.2798 14.6397 19.512 14.4125 20.3684 13.5561Z",
			fill: "white"
		})
	]
});
export default SvgUsersKeyIconWhite;
